import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_PL.json';
import exercises from './YOGA_EXERCISES_PL.json';
import recipes from './YOGA_RECIPES_PL.json';

export const YOGA_DATA_PL: ServiceData = {
  articles,
  exercises,
  recipes,
};
